import { echartSetOption } from './echarts-utils';

/* -------------------------------------------------------------------------- */
/*                             Echarts Total Sales                            */
/* -------------------------------------------------------------------------- */

const reportsDetailsChartInit = () => {
  const { getColor, getData, toggleColor } = window.phoenix.utils;
  // const phoenixTheme = window.config.config;
  const $chartEl = document.querySelector('.echart-reports-details');

  const tooltipFormatter = (params, dateFormatter = 'MMM DD') => {
    let tooltipItem = ``;
    params.forEach(el => {
      tooltipItem += `<div class='ms-1'>
          <h6 class="text-body-tertiary"><span class="fas fa-circle me-1 text-sm" style="color:${
            el.color
          }"></span>
            ${el.seriesName} : ${
        typeof el.value === 'object' ? el.value[1] : el.value
      }
          </h6>
        </div>`;
    });
    return `<div>
              <p class='mb-2 text-body-tertiary'>
                ${
                  window.dayjs(params[0].axisValue).isValid()
                    ? window.dayjs(params[0].axisValue).format('DD MMM, YYYY')
                    : params[0].axisValue
                }
              </p>
              ${tooltipItem}
            </div>`;
  };

  // const dates = getPastDates(7);
  const data = [64, 40, 45, 62, 82];

  if ($chartEl) {
    const userOptions = getData($chartEl, 'echarts');
    const chart = window.echarts.init($chartEl);

    const getDefaultOptions = () => ({
      color: [getColor('color-primary-lighter'), getColor('color-info-light')],
      tooltip: {
        trigger: 'axis',
        padding: [7, 10],
        backgroundColor: getColor('background-color-body-highlight'),
        borderColor: getColor('border-color-base'),
        textStyle: { color: getColor('text-color-light-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        },
        formatter: tooltipFormatter,
        extraCssText: 'z-index: 1000'
      },
      // legend: {
      //   left: '76%',
      //   top: 'auto',
      //   icon: 'circle',
      // },
      xAxis: {
        type: 'category',
        data: ['Analysis', 'Statement', 'Action', 'Offering', 'Interlocution'],
        axisLabel: {
          color: getColor('text-color-body'),
          fontFamily: 'Nunito Sans',
          fontWeight: 600,
          fontSize: 12.8,
          rotate: 30,
          formatter: value => `${value.slice(0, 5)}...`
        },
        axisLine: {
          lineStyle: {
            color: getColor('background-color-body-secondary')
          }
        },
        axisTick: false
      },
      yAxis: {
        type: 'value',
        splitLine: {
          lineStyle: {
            color: getColor('background-color-body-secondary')
          }
        },
        // splitLine: {
        //   show: true,
        //   lineStyle: {
        //     color: "rgba(217, 21, 21, 1)"
        //   }
        // },
        axisLabel: {
          color: getColor('text-color-body'),
          fontFamily: 'Nunito Sans',
          fontWeight: 700,
          fontSize: 12.8,
          margin: 24,
          formatter: value => `${value}%`
        }
      },
      series: [
        {
          name: 'Revenue',
          type: 'bar',
          barWidth: '32px',
          barGap: '48%',
          showBackground: true,
          backgroundStyle: {
            color: toggleColor(
              getColor('background-color-primary-subtle'),
              getColor('background-color-body-highlight')
            )
          },
          label: {
            show: false
          },
          itemStyle: {
            color: toggleColor(getColor('color-primary-light'), getColor('color-primary'))
          },
          data
        }
      ],
      grid: {
        right: '0',
        left: '0',
        bottom: 0,
        top: 10,
        containLabel: true
      },
      animation: false
    });

    echartSetOption(chart, userOptions, getDefaultOptions);
  }
};

export default reportsDetailsChartInit;
